import React, { useEffect, useState } from "react";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import { Autocomplete } from "@material-ui/lab";
import { Checkbox, colors, Divider, FormControlLabel, FormGroup, Fab, CircularProgress } from "@material-ui/core";
import {
  useStylesTF,
  useStylesTD,
  useStylesContainers,
  useStylesHed,
  // useStylesLbl,
  useStylesDPM,
  SaleCheckbox,
} from "../../../../../St/comps/UseStyle";
import { payTypes } from "../../../../../services/global-services";
import { useTranslation } from "react-i18next";
import { Directions } from "@material-ui/icons";
import { useStylesDTa } from "../../../../../St/comps/UseStyle";
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, makeStyles, IconButton } from '@material-ui/core'
import SaveIcon from "@material-ui/icons/Save";
import Cancel from "@material-ui/icons/Cancel";
import Button from "@material-ui/core/Button";

import { useStylesBA, useStylesCAB } from "../../../../../St/comps/UseStyle";
import { useStylesLbl } from "../../../../../St/Reports/UseStyle";

const useStyles = makeStyles(theme => ({
  dialog: {
    padding: theme.spacing(2),
    position: 'absolute',
    top: theme.spacing(5)
  },
  dialogTitle: {
    textAlign: 'center'
  },
  dialogContent: {
    textAlign: 'center'
  },
  dialogAction: {
    justifyContent: 'center'
  },
  titleIcon: {
    backgroundColor: theme.palette.secondary.light,
    color: theme.palette.secondary.main,
    '&:hover': {
      backgroundColor: theme.palette.secondary.light,
      cursor: 'default'
    },
    '& .MuiSvgIcon-root': {
      fontSize: '6rem',
    }
  }
}));

export default function PaidWindowForm(props) {
  const {
    idata,
    remains,
    setRemains,
    invDisc,
    payment,
    changPayment,
    buttonClassnameSavePMD,
    toDB, loading,
    handClosePMD,
    style,
    gets,
    openPMD,
    valueEmployePMD,
    transition,
    clasAo,
    valueBankPMD,
    changAutoBankPMD,
    changIdata,
    changAutoEmployee,
    valueType,
    valueAutoBankPaid,
    valueBanksPaid
  } = props;
  const clasPM = useStylesDPM();
  const clasTF = useStylesTF();
  const clasTD = useStylesTD();
  const clsConts = useStylesContainers();
  const claslbl = useStylesLbl();
  const { t } = useTranslation(["forms", "translation"]);
  const clasTa = useStylesDTa();


  const changeRemains = (key, value) => {
    if (key === "isCash" && value === false) {
      let all = remains.agelPart + remains.bankPart + remains.empPart + remains.networkPart;
      setRemains({ ...remains, [key]: value, cashPart: 0, allpart: all })
    } else if (key === "isNetwork" && value === false) {
      let all = remains.agelPart + remains.bankPart + remains.empPart + remains.cashPart;
      setRemains({ ...remains, [key]: value, networkPart: 0, allpart: all })
    } else if (key === "isBank" && value === false) {
      let all = remains.agelPart + remains.networkPart + remains.empPart + remains.cashPart;
      setRemains({ ...remains, [key]: value, bankPart: 0, allpart: all })
    } else if (key === "isEmp" && value === false) {
      let all = remains.agelPart + remains.networkPart + remains.bankPart + remains.cashPart;
      setRemains({ ...remains, [key]: value, empPart: 0, allpart: all })
    } else {
      if (key === "isNetwork") {
        setRemains({ ...remains, [key]: value, networkId: gets.Banks[0].id });
      } else if (key === "isBank") {
        setRemains({ ...remains, [key]: value, bankId: gets.Banks[0].id });
      } else {
        setRemains({ ...remains, [key]: value });
      }

    }
  }
  const onsave = (value) => {
    remains.empId = remains?.isEmp ? valueEmployePMD?.id : 0;
    remains.networkId = remains?.isNetwork ? valueBankPMD?.id : 0;
    remains.bankId = remains?.isNetwork ? valueBankPMD?.id : 0;

    if (remains.typePress == "save") {
      toDB("save", value);
    } else if (remains.typePress == "print") {
      toDB("print", value);
    }
  };

  const clasBA = useStylesBA();
  const clasCAB = useStylesCAB();
  const styBtn = {
    dis: { color: "#3b773d", background: "#4fa152" },
    undis: { color: "#fff" },
  };
  const changeTotals = (prop) => (event) => {
    
  };
  const [valueGroups, setValueGroups] = useState();
  const classes = useStyles()

  return (
    <div >
      <Dialog
        fullScreen
        className={clasPM.rootPM}
        open={openPMD}
        lg={{ direction: "rtl", minHeight: 600 }}
        onClose={handClosePMD}
        aria-labelledby="form-dialog-title"
        TransitionComponent={transition}
        key={transition ? transition.name : ""}
      >
        <DialogTitle id="form-dialog-title" className={claslbl.clor}>
          شاشة الدفع
        </DialogTitle>
        <DialogContent className={clasPM.dialogContentPM}>
          <Grid item container style={{ direction: "ltr" }} spacing={1}>
            <Grid
              item
              container
              lg={7}
              md={7}
              sm={12}
              xs={12}
              style={{ direction: "ltr" }}
              spacing={1}
            >
              <Grid item container className={clasPM.innerContinerPM} spacing={1}>
                <Grid item lg={8} md={8} sm={12} xs={8}>
                  <TextField
                    type="number"
                    fullWidth
                    variant="outlined"
                    size="small"
                    id="cashPart"
                    label="المبلغ النقدي"
                    className={clasTF.root}
                    // InputProps={{
                    //   className: clasTF.input,
                    // }}
                    InputLabelProps={{ shrink: true }}
                    InputProps={{
                      className: claslbl.clrBlackTxt,
                      readOnly: !remains.isCash,
                      onBlur: () => {
                        changeTotals("cashPart")
                      },
                    }}
                    name="cashPart"
                    disabled={!remains.isCash}
                    value={remains.cashPart}
                    placeholder="0"
                    onChange={changIdata("cashPart")}
                  />
                </Grid>

                <Grid
                  item
                  lg={4}
                  md={4}
                  sm={4}
                  xs={4}
                  className={clasPM.checkPM}
                >
                  <FormControlLabel
                    id="isCash"
                    value="isCash"
                    name="isCash"
                    className={claslbl.clor}
                    control={
                      <SaleCheckbox
                        checked={remains.isCash}
                        onChange={(e) => {
                          changeRemains('isCash', e.target.checked)
                        }}
                        color="primary"
                      />
                    }
                    label="دفع نقدي"
                    labelPlacement="start"
                  />
                </Grid>
              </Grid>

              <Grid item container className={clasPM.innerContinerPM} spacing={1}>
                <Grid
                  item
                  lg={5}
                  md={5}
                  sm={5}
                  xs={5}
                  className={clasPM.gridSpacePM}
                >
                  <TextField
                    type="number"
                    fullWidth
                    variant="outlined"
                    size="small"
                    id="networkPart"
                    label="مبلغ الشبكة"
                    className={clasTF.root}
                    InputProps={{
                      className: claslbl.clrBlackTxt,
                      readOnly: !remains.isNetwork,                   
                    }}
                    InputLabelProps={{ shrink: true, className: claslbl.clrBlackLblS }}
                    disabled={!remains.isNetwork}
                    name="networkPart"
                    value={remains.networkPart}
                    onChange={changIdata("networkPart")}
                  />
                </Grid>

                <Grid item lg={5} md={5} sm={5} xs={5}>
                  <Autocomplete
                    classes={clasAo}
                    value={valueBankPMD}
                    onChange={(event, newValue) => {
                      changAutoBankPMD(newValue);
                    }}
                    id="controllable-states-dem"
                    size="small"
                    options={gets.Banks}
                    getOptionLabel={(option) =>
                      typeof option === "string" ? option : option.name
                    }
                    style={{}}
                    disableClearable
                    disabled={!remains.isNetwork}
                    renderInput={(params) => (
                      <TextField
                        id="valueBankPMD"
                        {...params}
                        label={""}
                        variant="outlined"
                        size="small"
                        InputLabelProps={{ className: claslbl.clor }}
                      />
                    )}
                  />
                </Grid>
                <Grid
                  item
                  lg={2}
                  md={2}
                  sm={2}
                  xs={2}
                  className={clasPM.checkPM}
                >
                  <FormControlLabel
                    id="isNetwork"
                    value="isNetwork"
                    name="isNetwork"
                    InputLabelProps={{ shrink: true }}
                    className={claslbl.clor}
                    control={
                      <SaleCheckbox
                        checked={remains.isNetwork}
                        onChange={(e) => {
                          changeRemains('isNetwork', e.target.checked)
                        }}
                        color="primary"
                      />
                    }
                    label="دفع شبكة"
                    labelPlacement="start"
                  />
                </Grid>

              </Grid>

              <Grid item container className={clasPM.innerContinerPM} spacing={1}>
                <Grid item lg={8} md={8} sm={8} xs={8}>
                  <TextField
                    type="number"
                    fullWidth
                    variant="outlined"
                    size="small"
                    id="agelPart"
                    label="مبلغ الآجل"
                    className={clasTF.root}
                    InputProps={{
                      className: claslbl.clrBlackTxt,
                      readOnly: valueType.id == 1 ? false : true,                   
                    }}
                    disabled={!remains.isAgel}
                    InputLabelProps={{ shrink: true, className: claslbl.clrBlackLblS }}
                    name="agelPart"
                    value={remains.agelPart}
                    placeholder="0"
                    onChange={changIdata("agelPart")}
                  />
                </Grid>

                <Grid
                  item
                  lg={4}
                  md={4}
                  sm={4}
                  xs={4}
                  className={clasPM.checkPM}
                >
                  <FormControlLabel
                    id="isAgel"
                    value="isAgel"
                    name="isAgel"
                    className={claslbl.clor}
                    disabled={true}
                    control={
                      <SaleCheckbox
                        checked={remains.isAgel}
                        onChange={(e) => {
                          changeRemains('isAgel', e.target.checked)
                        }}
                        color="primary"
                      />
                    }
                    label="المبلغ آجل"
                    labelPlacement="start"
                  />
                </Grid>
              </Grid>

              <Grid item container className={clasPM.innerContinerPM} spacing={1}>
                <Grid
                  item
                  lg={4}
                  md={4}
                  sm={4}
                  xs={4}
                  className={clasPM.gridSpacePM}
                >
                  <TextField
                    type="number"
                    fullWidth
                    variant="outlined"
                    size="small"
                    id="bankPart"
                    label="مبلغ التحويل"
                    className={clasTF.root}
                    InputProps={{
                      className: claslbl.clrBlackTxt,
                      readOnly: !remains.isBank,                      
                    }}
                    InputLabelProps={{ shrink: true, className: claslbl.clrBlackLblS }}
                    disabled={!remains.isBank}
                    name="bankPart"
                    value={remains.bankPart}
                    placeholder="0"
                    onChange={changIdata("bankPart")}
                  />
                </Grid>

                <Grid item lg={5} md={5} sm={5} xs={5}>
                  <Autocomplete
                    classes={clasAo}
                    value={valueBanksPaid}
                    onChange={(event, newValue) => {
                      valueAutoBankPaid(newValue);
                    }}
                    id="controllable-states-dem"
                    size="small"
                    options={gets.Banks}
                    getOptionLabel={(option) =>
                      typeof option === "string" ? option : option.name
                    }
                    style={{}}
                    disableClearable
                    disabled={!remains.isBank}
                    renderInput={(params) => (
                      <TextField
                        id="valueBankPMD"
                        {...params}
                        label={""}
                        variant="outlined"
                        size="small"
                        InputLabelProps={{ className: claslbl.clor }}
                      />
                    )}
                  />
                </Grid>
                <Grid
                  item
                  lg={3}
                  md={3}
                  sm={3}
                  xs={3}
                  className={clasPM.checkPM}
                >
                  <FormControlLabel
                    id="isNetwork"
                    value="isNetwork"
                    name="isNetwork"
                    InputLabelProps={{ shrink: true }}
                    className={claslbl.clor}
                    control={
                      <SaleCheckbox
                        checked={remains.isBank}
                        onChange={(e) => {
                          changeRemains('isBank', e.target.checked)
                        }}
                        color="primary"
                      />
                    }
                    label="تحويل بنك"
                    labelPlacement="start"
                  />
                </Grid>

              </Grid>
              <Grid item container className={clasPM.innerContinerPM} spacing={1}>
                <Grid item lg={4} md={4} sm={4} xs={4}>
                  <TextField
                    type="number"
                    fullWidth
                    variant="outlined"
                    size="small"
                    id="empPart"
                    label="المبلغ"
                    className={clasTF.root}
                    InputProps={{
                    className: claslbl.clrBlackTxt,readOnly: !remains.isEmp, }}
                    InputLabelProps={{ shrink: true, className: claslbl.clrBlackLblS }}
                    disabled={!remains.isEmp}
                    name="empPart"
                    value={remains.empPart}
                    placeholder="0"
                    onChange={changIdata("empPart")}
                  />
                </Grid>

                <Grid item lg={5} md={5} sm={5} xs={5}>
                  <Autocomplete
                    classes={clasAo}
                    value={valueEmployePMD}
                    onChange={(event, newValue) => {
                      changAutoEmployee(newValue);
                    }}
                    id="controllable-states-dem"
                    size="small"
                    options={gets.Employees}
                    getOptionLabel={(option) =>
                      typeof option === "string" ? option : option.name
                    }
                    style={{}}
                    disableClearable
                    disabled={!remains.isEmp}
                    renderInput={(params) => (
                      <TextField
                        id="valueEmployePMD"
                        {...params}
                        label={""}
                        variant="outlined"
                        size="small"
                        InputLabelProps={{ className: claslbl.clor }}
                      />
                    )}
                  />
                </Grid>

                <Grid
                  item
                  lg={3}
                  md={3}
                  sm={3}
                  xs={2}
                  className={clasPM.checkPM}
                >
                  <FormControlLabel
                    id="isEmp"
                    value="isEmp"
                    name="isEmp"
                    className={claslbl.clor}
                    control={
                      <SaleCheckbox
                        checked={remains.isEmp}
                        onChange={(e) => {
                          changeRemains('isEmp', e.target.checked)
                        }}
                        color="primary"
                      />
                    }
                    label="على موظف"
                    labelPlacement="start"
                  />
                </Grid>
              </Grid>
              <Grid item container className={clasPM.innerContinerPM} spacing={1}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <TextField
                    type="number"
                    fullWidth
                    variant="outlined"
                    size="small"
                    id="allpart"
                    label="إجمالي المبالغ المستحقة"
                    className={clasTF.root}
                    InputProps={{className: claslbl.clrBlackTxt,readOnly:true,}}
                    InputLabelProps={{ shrink: true, className: claslbl.clrBlackLblS }}
                    name="allpart"
                    // placeholder="0"
                    value={parseFloat(remains.allpart).toFixed(2)}
                    placeholder="0"
                  />
                </Grid>
              </Grid>

            </Grid>

            <Grid
              item
              lg={5}
              md={5}
              sm={12}
              xs={12}
              className={clasPM.gridRigthPM}
              spacing={1}
            >
              <Grid item container className={clasPM.innerContinerPMEDS} spacing={1}>
                <Grid item lg={6} md={6} sm={6} xs={6} style={{ marginBottom: "0.7rem" }}>
                  <TextField
                    type="number"
                    fullWidth
                    variant="outlined"
                    size="small"
                    id="minusPMD"
                    label="إجمالي الخصم مبلغ"
                    className={clasTF.root}
                    InputProps={{ className: clasTF.input, readOnly: true }}
                    name="minusPMD"
                    value={invDisc.minus}
                    placeholder="0"
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>

                <Grid item lg={6} md={6} sm={6} xs={6} style={{ marginBottom: "0.7rem" }}>
                  <TextField
                    type="text"
                    fullWidth
                    variant="outlined"
                    size="small"
                    id="ratePMD"
                    label="إجمالي الخصم %"
                    className={clasTF.root}
                    InputProps={{ className: clasTF.input }}
                    name="ratePMD"
                    value={invDisc.rate}
                    placeholder="0"
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
              </Grid>

              <Grid item lg={12} md={12} sm={12} xs={12} style={{ marginBottom: "0.7rem" }} className={clasPM.innerContinerPMEDS}>
                <TextField
                  type="number"
                  fullWidth
                  variant="outlined"
                  size="small"
                  id="netAmount"
                  label="الإجــمالي"
                  className={clasTF.root}
                  InputProps={{ className: clasTF.input }}
                  name="netAmount"
                  value={idata.netAmount}
                />
              </Grid>

              <Grid item lg={12} md={12} sm={12} xs={12} style={{ marginBottom: "0.7rem" }} className={clasPM.innerContinerPMEDS}>
                <TextField
                  type="number"
                  fullWidth
                  variant="outlined"
                  size="small"
                  label="المبلغ المدفوع"
                  className={clasTF.root}
                  InputProps={{ className: clasTF.input }}
                  id="paidupPMDcn"
                  name="paidupPMDcn"
                  value={payment.paidupPMDcn}
                  placeholder="0"

                  onChange={changPayment("paidupPMDcn")}
                />
              </Grid>

              <Grid item lg={12} md={12} sm={12} xs={12} style={{ marginBottom: "0.7rem" }} className={clasPM.innerContinerPMEDS}>
                <TextField
                  type="number"
                  fullWidth
                  variant="outlined"
                  size="small"
                  label="البــاقي"
                  className={clasTF.root}
                  InputProps={{ className: clasTF.input }}
                  id="stayPMDcn"
                  name="stayPMDcn"
                  value={payment.stayPMDcn}
                  placeholder="0"
                  InputLabelProps={{ shrink: true }}
                />
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions className={clasPM.dirRPM}>
          <div className={clasCAB.wrapperCAB}>
            <Button
              variant="contained"
              color="primary"
              className={buttonClassnameSavePMD}
              disabled={loading.savePMD}
              onClick={() => onsave("e")}
            >
              {"Enter" + "  "} {"إتمام الدفع"}
            </Button>
            {loading.savePMD && (
              <CircularProgress
                size={24}
                className={clasCAB.buttonProgressCAB}
              />
            )}
          </div>

          <Button
            variant="contained"
            color="primary"
            onClick={() => handClosePMD("cancle")}
            style={{ ...style.bakClr }}
          >
            إلغاء
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
